module.exports = __webpack_public_path__ + "static/media/footer.8256c3f4.png";